import {IAirport} from '@/firebase/airport';
import {createSlice} from '@reduxjs/toolkit';

export interface AirportState {
  airlineStations: string[];
  airportDetail: IAirport | null;
  airportData: IAirport[];
  airportDataReady: boolean;
}

const initialState: AirportState = {
  airlineStations: [],
  airportDetail: null,
  airportData: [],
  airportDataReady: false
};

const airportSlice = createSlice({
  name: 'airportSlice',
  initialState,
  reducers: {
    setAirlineStations: (state, action) => {
      state.airlineStations = action.payload;
    },
    setAirportDetail: (state, action) => {
      state.airportDetail = action.payload;
    },
    setAirportData: (state, action) => {
      state.airportData = action.payload;
      state.airportDataReady = true;
    }
  }
});

export const {setAirlineStations, setAirportDetail, setAirportData} =
  airportSlice.actions;
export default airportSlice.reducer;
